import { Box, Skeleton, styled } from '@mui/material'

export const SkeletonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100vh - 180px)',
  maxHeight: '780px',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}))

export const PillsContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  height: 100,
  alignItems: 'center',
})

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
  backgroundColor: theme.palette.surface['900'],
}))

export const StatSkeletonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'column',
  },
}))

export const StatSkeleton = styled(StyledSkeleton)(({ theme }) => ({
  width: '15%',
  height: theme.spacing(12),
  [theme.breakpoints.up('md')]: {
    height: theme.spacing(3),
    width: '80%',
  },
}))

export const ModelSkeleton = styled(StyledSkeleton)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  width: '80%',
  marginLeft: 'auto',
  marginRight: 'auto',
  height: '100%',
  [theme.breakpoints.up('md')]: {
    width: '60%',
    marginLeft: 'auto',
    marginRight: 0,
  },
}))

export const LogoSkeleton = styled(StyledSkeleton)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  height: 80,
  width: '80%',
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('md')]: {
    width: 350,
  },
}))

export const ButtonSkeleton = styled(StyledSkeleton)(({ theme }) => ({
  height: 60,
  width: 200,
  marginBottom: theme.spacing(2),
  borderRadius: 10,
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('md')]: {
    marginLeft: 0,
    marginRight: 0,
  },
}))

export const PillsSkeleton = styled(StyledSkeleton)(({ theme }) => ({
  height: 50,
  width: '30%',
  borderRadius: 25,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    width: '15%',
  },
}))
